import styled from 'styled-components';
import tw from 'twin.macro';

/* The date control of the toolbar's scope band: the field, the shortcut back
 * to today beside it, and the box the calendar hangs in. The field and that
 * box are deliberately not the same element.
 *
 * DateInput drops its calendar into the nearest positioned ancestor and
 * provides none itself, precisely so the calendar is not capped at the width
 * of the field. Since the calendar is absolutely positioned, its own full
 * width and left edge resolve against this wrapper rather than against its
 * DOM parent — so the wrapper is what gives the calendar room and lines it up
 * with the field, while the field's own width sits on the DateInput below it.
 * Making the wrapper itself field-width would centre a 320px calendar over a
 * 176px box: sticking out equally both ways, and off the page on the left. */
export const DateField = styled.div`
  ${tw`relative flex items-center w-full min-w-0 space-x-8 z-100`}
  /* The calendar's own width (its 20rem minimum plus the padding around it),
     so it hangs under the field rather than centred across the whole row.
     Wider than the field and the button need, which is the point */
  max-width: 22rem;

  /* The field. It is the DateInput's root, the one child here that is a div —
     the shortcut beside it is a button */
  & > div {
    /* Not on the width scale, which stops at 48px: the width of a printed
       date plus the calendar button, in any of the offered date formats. It
       may still shrink where the row runs out of room, so that the shortcut
       stays whole */
    width: 11rem;
    max-width: 100%;
    /* DateInput reserves the calendar's height under itself, for the forms it
       was written for. Here the row is a fixed 48px and centres what is in it,
       so a reserved 300-odd pixels would push the field up out of the toolbar
       the moment the calendar opened. It overlays what is below instead */
    padding-bottom: 0;
  }

  /* Brought down to the 28px-plus-margins the toolbar's other controls stand
     at, so the field sits in the 48px row rather than filling it: a shorter
     line height on the input, and the same reduction on the margin around the
     calendar button, which is 28px tall in its own right. Both go through the
     wrapper rather than through DateInput's className, whose place in the
     class order is not deterministic (docs/conventions/03-styling.md) */
  & input {
    ${tw`leading-20 text-md`}
  }

  & input ~ div {
    ${tw`m-2`}
  }
`;
